module.exports = __webpack_public_path__ + "components/social-footer/static/twitter-b64dd6e2c60721bd47e33294a06d16e3.svg";